export default "__VITE_ASSET__rCtK7_94__"